export default {
	'custom-minus': {
		width: 31.427,
		height: 31.427,
		/* eslint-disable max-len */
		d: 'M1.111,16.832C0.492,16.832,0,16.325,0,15.706c0-0.619,0.492-1.111,1.111-1.111H30.3c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H1.111z'
	}
};
